import { User } from "./User";
import { Company } from "./Company";
import { BusinessDomain } from "./BusinessDomain";

/**
 * Enum for freelancer frequency options
 */
export enum FreelancerFrequency {
	Permanent = "Permanent",
	SeveralTimesYear = "SeveralTimesYear",
	OnceOrTwiceYear = "OnceOrTwiceYear",
	LessThanOnceYear = "LessThanOnceYear"
}

/**
 * Enum for communication channels
 */
export enum CommunicationChannel {
	Email = "Email",
	LinkedInMessaging = "LinkedInMessaging",
	SMS = "SMS",
	Phone = "Phone",
	WhatsApp = "WhatsApp"
}

/**
 * Interface for freelancer expertise
 */
export interface FreelancerExpertise {
	id: number;
	name: string;
	type: string;
}

/**
 * Interface for tool
 */
export interface Tool {
	id: number;
	label: string;
	capabilityCategory?: string;
}

/**
 * Interface for client
 */
export interface Client {
	userId: number;
	user: User;
	jobTitle?: string;
	companyId?: number;
	company?: Company;
	phoneNumber?: string;
	freelancerFrequency?: FreelancerFrequency;
	usesPlatforms?: boolean;
	preferredCommunicationChannels?: CommunicationChannel[];
	linkedInUrl?: string;
	onboardingCompleted: boolean;
	createdAt: string;
	updatedAt?: string;

	// Relationships
	freelancerExpertises: FreelancerExpertise[];
	businessDomains: BusinessDomain[];
	tools: Tool[];
}

/**
 * Interface for creating a client
 */
export interface ClientCreateRequest {
	jobTitle?: string;
	companyId?: number;
	phoneNumber?: string;
	freelancerFrequency?: FreelancerFrequency;
	usesPlatforms: boolean;
	preferredCommunicationChannels?: CommunicationChannel[];
	linkedInUrl?: string;
	onboardingCompleted: boolean;

	freelancerExpertiseIds: number[];
	businessDomainIds: number[];
	toolIds: number[];
}

/**
 * Interface for updating a client
 */
export interface ClientUpdateRequest {
	jobTitle?: string;
	companyId?: number;
	phoneNumber?: string;
	freelancerFrequency?: FreelancerFrequency;
	usesPlatforms?: boolean;
	preferredCommunicationChannels?: CommunicationChannel[];
	linkedInUrl?: string;
	onboardingCompleted?: boolean;

	freelancerExpertiseIds?: number[];
	businessDomainIds?: number[];
	toolIds?: number[];
}
